import React from 'react'

import { withContentful } from 'components/vendor/Contentful/withContentful'
import { CONTENTFUL_KEYS, EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import ProductPageLayout from './common/ProductPageLayout'
import { ExplorePageReduxProps } from 'types/page'

const AutoRefinancePage = ({ articles, getValue }: ExplorePageReduxProps): JSX.Element => {
	return (
		<ProductPageLayout
			articles={articles}
			title={
				<h1>
					{getValue(CONTENTFUL_KEYS.PRODUCTS.AUTO_REFINANCE.TITLE.FIRST)}{' '}
					<strong>{getValue(CONTENTFUL_KEYS.PRODUCTS.AUTO_REFINANCE.TITLE.SECOND)}</strong>
				</h1>
			}
			description={getValue(CONTENTFUL_KEYS.PRODUCTS.AUTO_REFINANCE.DESCRIPTION)}
		>
			<MultiProductWidget
				product={EMBED_PRODUCTS.LOAN}
				partner={EMBED_PARTNERS.FIONA}
				override={{ 'app.purpose': 'auto_refinance', loanPurposeOptions: 'auto_refinance', 'tag.page': 'auto_refi' }}
			/>
		</ProductPageLayout>
	)
}

export default withContentful(AutoRefinancePage)
